import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs font-semibold text-accent-600 uppercase tracking-widest mb-3">Browse Products</p>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 mb-4">
            Shop by Category
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Explore our complete Basetao spreadsheet product database across all 14 categories. Click any category to browse products on our main website.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative flex flex-col items-center overflow-hidden bg-background-100 hover:bg-background-200 rounded-xl border border-background-200/70 hover:border-accent-200 transition-all duration-200 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} products on Basetao spreadsheet`}
                  title={`Browse ${cat.name} on Basetao Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <span className="absolute bottom-2 left-2 right-2 text-center text-xs font-semibold text-white leading-tight drop-shadow-sm">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}